var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Icons',{attrs:{"icon":"copyright"}}),_vm._v(" 2024 Bossy Manager")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }